import { render, staticRenderFns } from "./ExpertApplyForTipsModal.vue?vue&type=template&id=6c1484eb&scoped=true"
import script from "./ExpertApplyForTipsModal.vue?vue&type=script&lang=js"
export * from "./ExpertApplyForTipsModal.vue?vue&type=script&lang=js"
import style0 from "./ExpertApplyForTipsModal.vue?vue&type=style&index=0&id=6c1484eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1484eb",
  null
  
)

export default component.exports